<template>
  <div class="myaccount-orders">
                        <h4 class="small-title">MY ORDERS</h4>
                        <div class="table-responsive">
                          <table class="table table-bordered table-hover">
                            <tbody>
                              <tr>
                                <th>ORDER</th>
                                <th>DATE</th>
                                <th>STATUS</th>
                                <th>TOTAL</th>
                                <th></th>
                              </tr>
                              <tr v-for="order in orders" :key="order.numOrder">
                                <td><a class="account-order-id" href="javascript:void(0)">#{{ order.numOrder }}</a></td>
                                <td>{{order.date}}</td>
                                <td>{{order.status}}</td>
                                <td>{{order.total}}</td>
                                <td><a href="javascript:void(0)"
                                    class="uren-btn uren-btn_dark uren-btn_sm"><span>View</span></a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
</template>

<script>
export default {
  name: "MyOrders",
  props: ["orders"],
}
</script>

<style>

</style>
